<template>
  <a-drawer
    :maskClosable="false"
    width="80%"
    title="设备返修详情"
    placement="right"
    :closable="true"
    :visible="visible"
    @close="onClose"
  >
    <a-tabs @change="callback" :activeKey="active" type="card">
      <a-tab-pane :key="1" tab="基本信息">
        <a-descriptions title="订单状态" :column="4" bordered class="info-section">
          <a-descriptions-item label="处理状态">
            <a-tag :color="repairStatusTag.color">{{ repairStatusTag.text }}</a-tag>
          </a-descriptions-item>
          <a-descriptions-item label="处理方式">
            <a-tag :color="handleTypeTag.color">{{ handleTypeTag.text }}</a-tag>
          </a-descriptions-item>
          <a-descriptions-item label="是否在保修期">
            <a-tag :color="form.warrantyFlag === 1 ? 'green' : 'red'">
              {{ form.warrantyFlag === 1 ? '是' : '否' }}
            </a-tag>
          </a-descriptions-item>
          <a-descriptions-item label="支付状态">
            <a-tag :color="payStatusTag.color">{{ payStatusTag.text }}</a-tag>
          </a-descriptions-item>
        </a-descriptions>

        <a-descriptions title="企业与设备信息" :column="2" bordered class="info-section">
          <a-descriptions-item label="企业名称">{{ form.companyName || '--' }}</a-descriptions-item>
          <a-descriptions-item label="处理人">{{ form.processorName || '--' }}</a-descriptions-item>
          <a-descriptions-item label="原设备地址" :span="2">
            <div v-if="macAddressList.length > 0" style="display: flex; flex-wrap: wrap; gap: 8px">
              <a-tag v-for="(mac, index) in macAddressList" :key="index" color="blue">{{ mac }}</a-tag>
            </div>
            <span v-else>--</span>
          </a-descriptions-item>
          <a-descriptions-item label="新设备地址" :span="2">
            <div v-if="newMacAddressList.length > 0" style="display: flex; flex-wrap: wrap; gap: 8px">
              <a-tag v-for="(mac, index) in newMacAddressList" :key="index" color="green">{{ mac }}</a-tag>
            </div>
            <span v-else>--</span>
          </a-descriptions-item>
        </a-descriptions>

        <a-descriptions title="寄件信息" :column="2" bordered class="info-section">
          <a-descriptions-item label="寄件人">{{ form.senderName || '--' }}</a-descriptions-item>
          <a-descriptions-item label="联系电话">{{ form.senderPhone || '--' }}</a-descriptions-item>
          <a-descriptions-item label="寄件地址" :span="2">{{ form.senderAddress || '--' }}</a-descriptions-item>
          <a-descriptions-item label="快递公司">{{ form.sendCompany == 0 ? '京东物流' : '顺丰' }}</a-descriptions-item>
          <a-descriptions-item label="客户寄出单号">
            {{ form.mailNo || '--' }}
            <a-button v-if="form.mailNo" type="link" size="small" @click="handleViewLogistics(form.mailNo, '寄件')">
              查询物流
            </a-button>
          </a-descriptions-item>
          <a-descriptions-item label="厂家寄回单号" :span="2">
            {{ form.returnMailNo || '--' }}
            <a-button
              v-if="form.returnMailNo"
              type="link"
              size="small"
              @click="handleViewLogistics(form.returnMailNo, '回件')"
            >
              查询物流
            </a-button>
          </a-descriptions-item>
        </a-descriptions>

        <a-descriptions title="故障信息" :column="2" bordered class="info-section">
          <a-descriptions-item label="故障类型">{{ form.problemType || '--' }}</a-descriptions-item>
          <a-descriptions-item label="故障原因">{{ form.faultCause || '--' }}</a-descriptions-item>
          <a-descriptions-item label="故障描述" :span="2">{{ form.problemDescription || '--' }}</a-descriptions-item>
          <a-descriptions-item label="故障照片" :span="2" v-if="form.photoPaths && form.photoPaths.length > 0">
            <div v-viewer>
              <img
                v-for="(url, i) in form.photoPaths"
                :key="i"
                :src="$url + url"
                class="preview-img"
                @error="(e) => (e.target.src = errorImage)"
              />
            </div>
          </a-descriptions-item>
        </a-descriptions>

        <a-descriptions title="维修信息" :column="2" bordered class="info-section">
          <a-descriptions-item label="维修内容" :span="2">{{ form.repairContent || '--' }}</a-descriptions-item>
          <a-descriptions-item label="确认收货图片" :span="2" v-if="form.receiptImages">
            <div v-viewer>
              <img
                v-for="(url, i) in receiptImageList"
                :key="i"
                :src="$url + url"
                class="preview-img"
                @error="(e) => (e.target.src = errorImage)"
              />
            </div>
          </a-descriptions-item>
        </a-descriptions>

        <a-descriptions title="时间信息" :column="2" bordered class="info-section">
          <a-descriptions-item label="创建时间">{{ form.createTime || '--' }}</a-descriptions-item>
          <a-descriptions-item label="确认收货时间">{{ form.receiptTime || '--' }}</a-descriptions-item>
          <a-descriptions-item label="审核时间">{{ form.auditTime || '--' }}</a-descriptions-item>
          <a-descriptions-item label="维修完成时间">{{ form.completionTime || '--' }}</a-descriptions-item>
        </a-descriptions>

        <a-descriptions
          title="备注信息"
          :column="1"
          bordered
          class="info-section"
          v-if="form.auditRemark || form.remark"
        >
          <a-descriptions-item label="审核备注" v-if="form.auditRemark">{{ form.auditRemark }}</a-descriptions-item>
          <a-descriptions-item label="备注" v-if="form.remark">{{ form.remark }}</a-descriptions-item>
        </a-descriptions>
      </a-tab-pane>

      <a-tab-pane :key="2" tab="维修清单">
        <a-descriptions :column="2" bordered class="full-width-descriptions" style="margin-bottom: 16px">
          <a-descriptions-item label="总费用">
            <span style="font-size: 18px; font-weight: bold; color: #f5222d"> ¥{{ form.totalAmount || 0 }} </span>
            <span v-if="form.warrantyFlag === 1" style="margin-left: 8px; color: #52c41a">(保修期内免费)</span>
          </a-descriptions-item>
          <a-descriptions-item label="支付状态">
            <a-tag :color="payStatusTag.color">{{ payStatusTag.text }}</a-tag>
          </a-descriptions-item>
        </a-descriptions>

        <a-table
          :columns="repairItemColumns"
          :data-source="form.repairItems || []"
          :pagination="false"
          rowKey="id"
          bordered
          size="small"
        >
          <span slot="amount" slot-scope="text">¥{{ text || 0 }}</span>
          <span slot="unitPrice" slot-scope="text">¥{{ text || 0 }}</span>
        </a-table>
      </a-tab-pane>

      <a-tab-pane :key="3" tab="维修设备">
        <div v-if="form.repairMacs && form.repairMacs.length > 0" style="margin-bottom: 16px">
          <a-button
            type="primary"
            :disabled="selectedMacIds.length === 0"
            @click="handleBatchReturnMac"
            :loading="batchReturnLoading"
          >
            批量单独寄回 (已选择 {{ selectedMacIds.length }} 项)
          </a-button>
        </div>
        <a-table
          v-if="form.repairMacs && form.repairMacs.length > 0"
          :columns="macColumns"
          :data-source="form.repairMacs"
          :pagination="false"
          :row-selection="macRowSelection()"
          rowKey="id"
          bordered
          size="small"
        >
          <template slot="newMacAddress" slot-scope="text">
            {{ text || '--' }}
          </template>
          <template slot="devFirstTime" slot-scope="text">
            {{ text || '--' }}
          </template>
          <template slot="mailStatus" slot-scope="text">
            <a-tag :color="text === 1 ? 'green' : 'orange'">
              {{ text === 1 ? '已寄回' : '待寄回' }}
            </a-tag>
          </template>
          <template slot="returnMailNo" slot-scope="text">
            {{ text || '--' }}
          </template>
          <template slot="action" slot-scope="text, record">
            <a-button v-if="canReturnMac(record)" type="primary" size="small" @click="handleReturnMac(record)">
              单独寄回
            </a-button>
            <span v-else style="color: #999">--</span>
          </template>
        </a-table>
        <a-empty v-else description="暂无维修设备MAC" />
      </a-tab-pane>

      <a-tab-pane :key="4" tab="处理信息">
        <a-descriptions :column="1" bordered class="full-width-descriptions">
          <a-descriptions-item label="寄件信息">
            <p>寄件人：{{ form.senderName }}</p>
            <p>联系电话：{{ form.senderPhone }}</p>
            <p>详细地址：{{ form.senderAddress || '--' }}</p>
            <p>快递公司：{{ form.sendCompany == 0 ? '京东物流' : '顺丰' }}</p>
            <p>客户寄出单号：{{ form.mailNo || '--' }}</p>
          </a-descriptions-item>

          <a-descriptions-item label="返修信息">
            <p>处理方式：{{ handleTypeTag.text }}</p>
            <p>处理人：{{ form.processorName || '--' }}</p>
            <p>维修内容：{{ form.repairContent || '--' }}</p>
            <p>厂家寄回单号：{{ form.returnMailNo || '--' }}</p>
          </a-descriptions-item>

          <a-descriptions-item label="时间信息">
            <p>创建时间：{{ form.createTime || '--' }}</p>
            <p>确认收货时间：{{ form.receiptTime || '--' }}</p>
            <p>审核时间：{{ form.auditTime || '--' }}</p>
            <p>维修完成时间：{{ form.completionTime || '--' }}</p>
          </a-descriptions-item>
        </a-descriptions>
      </a-tab-pane>
    </a-tabs>

    <a-modal
      :title="logisticsType + '物流信息'"
      :visible="logisticsVisible"
      :footer="null"
      @cancel="logisticsVisible = false"
      width="600px"
      :bodyStyle="{ maxHeight: '70vh', overflowY: 'auto', padding: '24px' }"
    >
      <a-spin :spinning="logisticsLoading">
        <div v-if="logisticsList.length > 0">
          <p style="margin-bottom: 16px"><strong>快递单号：</strong>{{ currentMailNo }}</p>
          <a-timeline>
            <a-timeline-item
              v-for="(item, index) in logisticsList"
              :key="index"
              :color="index === 0 ? 'green' : 'gray'"
            >
              <p style="margin-bottom: 4px">
                <strong>{{ item.operationTitle }}</strong>
              </p>
              <p style="margin-bottom: 4px; color: #666">{{ item.operationRemark }}</p>
              <p style="margin-bottom: 0; color: #999; font-size: 12px">{{ item.operationTime }}</p>
            </a-timeline-item>
          </a-timeline>
        </div>
        <a-empty v-else description="暂无物流信息" />
      </a-spin>
    </a-modal>

    <confirm-shipment-mac ref="confirmShipmentMacDrawer" @ok="refreshDetail" />
  </a-drawer>
</template>

<script>
import { getObj, getJdLogistics, returnRepairMac } from '@/api/fix/devRepair'
import ConfirmShipmentMac from './ConfirmShipmentMac.vue'

export default {
  name: 'DevRepairDetail',
  components: {
    ConfirmShipmentMac,
  },
  data() {
    return {
      visible: false,
      form: {},
      errorImage: require('@/assets/images/defaultImg.png'),
      active: 1,
      logisticsVisible: false,
      logisticsLoading: false,
      logisticsList: [],
      currentMailNo: '',
      logisticsType: '',
      macColumns: [
        {
          title: 'MAC地址',
          dataIndex: 'macAddress',
          key: 'macAddress',
          align: 'center',
        },
        {
          title: '新MAC地址',
          dataIndex: 'newMacAddress',
          key: 'newMacAddress',
          align: 'center',
          scopedSlots: { customRender: 'newMacAddress' },
        },
        {
          title: '设备首次使用时间',
          dataIndex: 'devFirstTime',
          key: 'devFirstTime',
          align: 'center',
        },
        {
          title: '邮寄状态',
          dataIndex: 'mailStatus',
          key: 'mailStatus',
          align: 'center',
          scopedSlots: { customRender: 'mailStatus' },
        },
        {
          title: '寄回单号',
          dataIndex: 'returnMailNo',
          key: 'returnMailNo',
          align: 'center',
        },
        {
          title: '操作',
          key: 'action',
          align: 'center',
          width: '120px',
          scopedSlots: { customRender: 'action' },
        },
      ],
      selectedMacIds: [],
      batchReturnLoading: false,
      repairItemColumns: [
        {
          title: '维修项名称',
          dataIndex: 'itemName',
          key: 'itemName',
          align: 'center',
          width: '150px',
        },
        {
          title: '费用类型',
          dataIndex: 'itemType',
          key: 'itemType',
          align: 'center',
        },
        {
          title: '单价',
          dataIndex: 'unitPrice',
          key: 'unitPrice',
          align: 'center',
          scopedSlots: { customRender: 'unitPrice' },
        },
        {
          title: '数量',
          dataIndex: 'quantity',
          key: 'quantity',
          align: 'center',
        },
        {
          title: '小计',
          dataIndex: 'amount',
          key: 'amount',
          align: 'center',
          scopedSlots: { customRender: 'amount' },
        },
        {
          title: '备注',
          dataIndex: 'remark',
          key: 'remark',
          align: 'center',
        },
      ],
    }
  },
  computed: {
    handleTypeTag() {
      const map = {
        0: { text: '维修', color: 'blue' },
        1: { text: '换新', color: 'green' },
      }
      return map[this.form.handleType] || { text: '未知', color: 'default' }
    },
    repairStatusTag() {
      if (this.form.repairStatus === 2) {
        if (this.form.payStatus === 0) {
          return { text: '待支付', color: 'gold' }
        } else {
          return { text: '已支付', color: 'green' }
        }
      }
      const map = {
        0: { text: '待收货', color: 'orange' },
        1: { text: '待审核', color: 'blue' },
        3: { text: '维修中', color: 'purple' },
        4: { text: '待寄回', color: 'cyan' },
        5: { text: '已邮寄', color: 'geekblue' },
        6: { text: '已完成', color: 'green' },
        10: { text: '已取消', color: 'grey' },
      }
      return map[this.form.repairStatus] || { text: '未知', color: 'default' }
    },
    payStatusTag() {
      const map = {
        0: { text: '未支付', color: 'orange' },
        1: { text: '已支付', color: 'green' },
        2: { text: '退款中', color: 'gold' },
        3: { text: '已退款', color: 'blue' },
      }
      return map[this.form.payStatus] || { text: '未知', color: 'default' }
    },
    receiptImageList() {
      if (!this.form.receiptImages) return []
      return this.form.receiptImages.split(',').filter((url) => url)
    },
    sendCompanyText() {
      const map = {
        0: '京东物流',
        1: '顺丰',
      }
      return map[this.form.sendCompany] || '--'
    },
    macAddressList() {
      if (!this.form.macAddress) return []
      return this.form.macAddress.split(',').filter((mac) => mac && mac.trim())
    },
    newMacAddressList() {
      if (!this.form.newMacAddress) return []
      return this.form.newMacAddress.split(',').filter((mac) => mac && mac.trim())
    },
  },
  methods: {
    init(record) {
      this.refreshDetail(record.id)
      this.visible = true
    },
    refreshDetail(id) {
      if (!id && this.form.id) {
        id = this.form.id
      }
      if (id) {
        getObj(id).then((res) => {
          this.form = res.data
          if (this.form.repairMacs && this.selectedMacIds.length > 0) {
            this.selectedMacIds = this.selectedMacIds.filter((key) => {
              const record = this.form.repairMacs.find((mac) => mac.id === key)
              return record && record.mailStatus !== 1 && record.mailStatus !== '1'
            })
          }
        })
      }
    },
    onClose() {
      this.visible = false
      this.form = {}
      this.selectedMacIds = []
    },
    callback(key) {
      this.active = key
    },
    macRowSelection() {
      return {
        selectedRowKeys: this.selectedMacIds,
        onChange: (selectedRowKeys) => {
          const validKeys = selectedRowKeys.filter((key) => {
            const record = this.form.repairMacs?.find((mac) => mac.id === key)
            return record && record.mailStatus !== 1
          })
          this.selectedMacIds = validKeys
        },
        getCheckboxProps: (record) => {
          const isReturned = record.mailStatus === 1 || record.mailStatus === '1'
          const isDisabled = isReturned || !this.canReturnMac(record)
          return {
            props: {
              disabled: isDisabled,
            },
          }
        },
      }
    },
    handleViewLogistics(mailNo, type) {
      this.currentMailNo = mailNo
      this.logisticsType = type
      this.logisticsVisible = true
      this.logisticsLoading = true
      this.logisticsList = []
      getJdLogistics(mailNo)
        .then((res) => {
          this.logisticsList = res.data || []
        })
        .catch(() => {
          this.$message.error('获取物流信息失败')
        })
        .finally(() => {
          this.logisticsLoading = false
        })
    },
    canReturnMac(macRecord) {
      if (this.form.repairStatus !== 5 && this.form.repairStatus !== 6) {
        return false
      }
      if (macRecord.mailStatus === 1) {
        return false
      }
      return macRecord.mailStatus === 0 && !macRecord.returnMailNo
    },
    handleReturnMac(macRecord) {
      this.$refs.confirmShipmentMacDrawer.init({
        id: this.form.id,
        macId: macRecord.id,
        macAddress: macRecord.macAddress,
      })
    },
    handleBatchReturnMac() {
      if (this.selectedMacIds.length === 0) {
        this.$message.warning('请至少选择一个MAC设备')
        return
      }

      const selectedMacs = this.form.repairMacs.filter((mac) => this.selectedMacIds.includes(mac.id))
      const invalidMacs = selectedMacs.filter((mac) => !this.canReturnMac(mac))

      if (invalidMacs.length > 0) {
        this.$message.warning('所选设备中包含不符合寄回条件的设备，请重新选择')
        return
      }

      this.$confirm({
        title: '确认批量寄回',
        content: `确定要批量寄回 ${this.selectedMacIds.length} 个MAC设备吗？`,
        onOk: () => {
          this.batchReturnLoading = true
          const submitData = {
            id: this.form.id,
            macIds: this.selectedMacIds,
          }

          returnRepairMac(submitData)
            .then(() => {
              this.$message.success('批量寄回操作成功', 3)
              this.selectedMacIds = []
              this.refreshDetail()
            })
            .catch(() => {})
            .finally(() => {
              this.batchReturnLoading = false
            })
        },
      })
    },
  },
}
</script>

<style lang="less" scoped>
.full-width-descriptions {
  width: 100%;
}
.info-section {
  margin-bottom: 24px;
}
:deep(.ant-descriptions-item-label) {
  width: 120px;
  min-width: 120px;
  text-align: right;
  white-space: nowrap;
  overflow: visible;
}
.preview-img {
  width: 80px;
  height: 80px;
  margin-right: 8px;
  cursor: pointer;
  border-radius: 4px;
  object-fit: cover;
}
</style>
